import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { UserPlus, Share2, Wallet } from 'lucide-react';

const steps = [
  {
    number: 1,
    icon: UserPlus,
    get title() { return translateInterfaceText("Cadastre-se"); },
    get description() { return translateInterfaceText("Faça uma nova conta de parceiro e gere a sua conta de parceiro."); }
  },
  {
    number: 2,
    icon: Share2,
    get title() { return translateInterfaceText("Compartilhe seu link"); },
    get description() { return translateInterfaceText("Receba seu link exclusivo e indique para sua audiência."); }
  },
  {
    number: 3,
    icon: Wallet,
    get title() { return translateInterfaceText("Ganhe comissão recorrente"); },
    get description() { return translateInterfaceText("Receba 20% do valor de cada cliente ativo todos os meses."); }
  }
];

export function ReferralSteps() {
  useLanguage();
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl lg:text-2xl font-bold text-foreground">
          {translateInterfaceText("Como Funciona")}</h3>
        <p className="text-muted-foreground">
          {translateInterfaceText("Apenas 3 passos simples para começar a ganhar")}</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map((step) => (
          <Card key={step.number} className="text-center relative">
            <CardHeader>
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm">
                {step.number}
              </div>
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto mb-2 mt-4">
                <step.icon className="w-6 h-6 text-primary" />
              </div>
              <CardTitle className="text-base">{step.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {step.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
